import React from "react";
import { ViewMode, Gantt, type Task } from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import { remindersAndEvents } from "./mocks/calendarMocks";

const GanttChart: React.FC = () => {
  const tasks: Task[] = remindersAndEvents.map(item => {
    const color = item.type === "event" ? "blue" : "orange";
    const dependencies = remindersAndEvents
      .filter(reminder => reminder.parentId === item.id)
      .map(reminder => reminder.id);

    const startDate = new Date(item.datetime);
    const endDate = new Date(startDate);
    endDate.setHours(startDate.getHours() + 2); // assuming each event lasts 2 hours

    return {
      start: startDate,
      end: endDate,
      name: item.title,
      id: item.id,
      type: "task",
      progress: 100, // assuming all tasks are completed
      isDisabled: false,
      dependencies: dependencies,
      styles: { progressColor: color, progressSelectedColor: color },
    };
  });

  return (
    <div className="overflow-x-auto p-4">
      <h1 className="mb-4 text-2xl font-bold">Gantt Chart</h1>
      <div className="rounded-lg bg-white p-6 shadow-md">
        <div className="flex flex-col">
          <div className="flex-1">
            <Gantt tasks={tasks} viewMode={ViewMode.Day} columnWidth={70} locale="en" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GanttChart;
